var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3402 16.5504C12.3085 16.6973 12.3085 19.6369 14.3402 19.7839H19.1474C19.7267 19.7839 20.2973 19.5678 20.7209 19.1787C22.1475 17.9337 21.3867 15.4437 19.5105 15.2102C18.8361 11.1553 12.9742 12.6943 14.3576 16.559",
    fill: "#0068FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3402 16.5504C12.3085 16.6973 12.3085 19.6369 14.3402 19.7839H19.1474C19.7267 19.7839 20.2973 19.5678 20.7209 19.1787C22.1475 17.9337 21.3867 15.4437 19.5105 15.2102C18.8361 11.1553 12.9742 12.6943 14.3576 16.559",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87186 18.2287L5.22457 13.5814C4.20639 12.5632 4.20639 10.8905 5.22457 9.86502L9.87186 5.21774C10.89 4.19956 12.5628 4.19956 13.5882 5.21774L18.2355 9.86502",
    stroke: "#0068FF",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/layer-2.b79e22e44b153e22d0a371cd5976a178.svg";
export { ForwardRef as ReactComponent };